import React, { ReactNode } from 'react';
import { DatePicker } from 'antd';

type SignUpFormItem = {
  type: 'text' | 'email' | 'password' | 'custom';
  label: string;
  name: string;
  rules?: Array<{ required: boolean }>;
  render?: () => ReactNode;
};

const signUpSuperUsersFormItems: SignUpFormItem[] = [
  {
    type: 'email',
    label: 'Email Address',
    name: 'email',
    rules: [
      {
        required: true,
      },
    ],
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    rules: [
      {
        required: true,
      },
    ],
  },
  {
    type: 'custom',
    label: 'Deactivation Date',
    name: 'deactivation_date',
    render: () => <DatePicker />,
  },
];

export default signUpSuperUsersFormItems;
